import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import GestureHandler from "./GestureHandler";
/**
 * The base class for **Rotation** and **Pinch** gesture handlers.
 */ var IndiscreteGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(IndiscreteGestureHandler, GestureHandler);
    var _super = _create_super(IndiscreteGestureHandler);
    function IndiscreteGestureHandler() {
        _class_call_check(this, IndiscreteGestureHandler);
        return _super.apply(this, arguments);
    }
    _create_class(IndiscreteGestureHandler, [
        {
            key: "shouldEnableGestureOnSetup",
            get: function get() {
                return false;
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_minPointers = _param.minPointers, minPointers = _param_minPointers === void 0 ? 2 : _param_minPointers, _param_maxPointers = _param.maxPointers, maxPointers = _param_maxPointers === void 0 ? 2 : _param_maxPointers, props = _object_without_properties(_param, [
                    "minPointers",
                    "maxPointers"
                ]);
                return _get(_get_prototype_of(IndiscreteGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    minPointers: minPointers,
                    maxPointers: maxPointers
                }, props));
            }
        },
        {
            key: "isGestureEnabledForEvent",
            value: function isGestureEnabledForEvent(param, _recognizer, param1) {
                var minPointers = param.minPointers, maxPointers = param.maxPointers, pointerLength = param1.maxPointers;
                if (pointerLength > maxPointers) {
                    return {
                        failed: true
                    };
                }
                var validPointerCount = pointerLength >= minPointers;
                return {
                    success: validPointerCount
                };
            }
        }
    ]);
    return IndiscreteGestureHandler;
}(GestureHandler);
export default IndiscreteGestureHandler;
